'use strict';

var _ = require('lodash');
var FlightLastYearFilterFactory = function FlightLastYearFilterFactory() {
  function FlightLastYearFilter() {
    this.sourceType = ['cabin', 'cabin-deep'];
  }
  FlightLastYearFilter.constructor = FlightLastYearFilter;
  FlightLastYearFilter.prototype.canFilterBeforeTransform = function (sourceType) {
    return this.sourceType.indexOf(sourceType) !== -1;
  };
  function filterDomainData(data) {
    if (_.get(data, 'results') === undefined) {
      return data;
    }
    var realFlights = _.filter(data.results, function (f) {
      return f.flightId !== undefined;
    });
    var realFlightIdsMap = _.reduce(realFlights, pickFlightId, {});
    var uniqueLYOnlyFlights = _.chain(data.results).filter(function (f) {
      var isLYOnlyFlight = f.flightId === undefined;
      var noRealFlight = !realFlightIdsMap[f.referenceCurveFlightId];
      return isLYOnlyFlight && noRealFlight;
    }).uniqBy(lyOnlyFlightUniqueId).value();
    data.results = _.concat(realFlights, uniqueLYOnlyFlights);
    return data;
  }
  function pickFlightId(result, row) {
    if (row.flightId) {
      result[row.referenceCurveFlightId] = true;
    }
    return result;
  }
  function lyOnlyFlightUniqueId(row) {
    return row.referenceCurveFlightId + row.leg + row.cabinCode;
  }
  FlightLastYearFilter.prototype.filter = function (data) {
    data.domain = filterDomainData(data.domain);
    data.secondDomain = filterDomainData(data.secondDomain);
    data.thirdDomain = filterDomainData(data.thirdDomain);
    return data;
  };
  return FlightLastYearFilter;
};
FlightLastYearFilterFactory.$inject = [];
module.exports = FlightLastYearFilterFactory;